var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOngoing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#ongoing_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.33,
  d: "M10.077.665a9.2 9.2 0 0 1 6.66 2.826l.47.484 1.836-1.836v5.173H13.87l1.386-1.386.46-.46-.45-.47a7.14 7.14 0 0 0-5.193-2.225c-.413 0-.83.035-1.238.106-2.436.423-4.557 2.172-5.467 4.482H1.141A9.33 9.33 0 0 1 10.077.665Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.175 11.976h-2.708a.425.425 0 0 0-.4.278c-.792 2.168-2.761 3.821-5.016 4.213a6.6 6.6 0 0 1-1.125.097 6.47 6.47 0 0 1-4.713-2.02L7.01 12.75a.425.425 0 0 0-.3-.726H.716a.425.425 0 0 0-.425.425v5.992a.425.425 0 0 0 .726.3l1.768-1.768A9.88 9.88 0 0 0 9.923 20c.572 0 1.15-.05 1.715-.148a10 10 0 0 0 7.949-7.345.426.426 0 0 0-.412-.531"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ongoing_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgOngoing;